import { getGDriveItem } from 'owa-fileprovider-services';
import getGDriveItemIdFromShareUrl from './getGDriveItemIdFromShareUrl';

import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';

// To preview non-image GDrive files, need to convert the webContentLink url
const SUFFIX_TO_REMOVE = 'download';
const SUFFIX_TO_ADD = 'open';

export default async function getGDriveNonImagePreviewUrl(
    referenceAttachment: ReferenceAttachment
): Promise<string | null> {
    // This throws if getGDriveItemIdFromShareUrl() throws
    const itemId = getGDriveItemIdFromShareUrl(referenceAttachment.AttachLongPathName);
    const response = await getGDriveItem(itemId);
    return response.result?.webContentLink && hasUrlExpectedFormat(response.result.webContentLink)
        ? convertUrlToPreviewUrl(response.result.webContentLink)
        : null;
}

function hasUrlExpectedFormat(url: string) {
    return url.lastIndexOf(SUFFIX_TO_REMOVE, url.length - SUFFIX_TO_REMOVE.length) > -1;
}

function convertUrlToPreviewUrl(url: string): string | null {
    return url.slice(0, -SUFFIX_TO_REMOVE.length) + SUFFIX_TO_ADD;
}
